<i18n locale="th" lang="yaml" >
chart.name : "Drone ที่ลงทะเบียน (ตามวันรับประกัน)"
chart.summary : "มีจำนวน Drone ลงทะเบียนทั้งหมด {total} @:common.drone.unit"
</i18n>

<template>
	<ChartContainer
		ref="container"
		:loading="loading"
		:is-empty="total <= 0"
		:error-message="error"
		:summary="summary"
		v-bind="$attrs">
		<LineChart ref="chart" :hide-legend="true"/>
		<span slot="title">
			{{$t('chart.name')}} <br/>
			<b>{{lotName}}</b>
		</span>
	</ChartContainer>
</template>

<script>
import axios from "axios"
import ChartContainer from "./general/ChartContainer.vue"
import LineChart from "./general/LineChart.vue"
import ApiError from '@utils/errors/ApiError'

export default {
	components : {
		ChartContainer , LineChart
	} ,
	props : {
		lotName : {
			type : String,
			default : undefined
		} ,
		lotId : {
			type : String,
			default : undefined,
		}
	} ,
	data() {
		return {
			total : 0,
			loading : false,
			error : undefined,
		}
	} ,
	computed : {
		summary() {
			if(this.total <=0)
				return undefined;
			else
				return this.$t('chart.summary',{total : this.total})
		}
	} ,
	watch :{
		lotId() {
			this.fetchData()
		}
	} ,
	mounted() {
		this.fetchData()
	} ,
	methods : {
		reset() {
			this.total = 0
			this.error = null
			this.loading = false
		} ,
		convertDataset(dataset,dataLabels) {
			if (!this.$notEmpty(dataset))
				return null

			const labels = ['',...Object.values(dataLabels)]
			const statData = [0]
			const color = "#1890ff"
			for(const key in dataLabels) {
				if (key in dataset) {
					statData.push(dataset[key])
				} else {
					statData.push(0)
				}
			}

			return {
				labels ,
				datasets : [
					{
						backgroundColor : color,
						borderColor : color,
						data : statData,
						fill : false,
					}
				]
			}
		} ,
		fetchData() {
			this.reset()
			if (this.lotId <= 0) {
				this.$refs.chart.applyChartData()
				return;
			}


			this.loading = true
			this.error = undefined
			axios.get("/api/drone-lots/2925d40a-53e4-4bca-b8df-97683f0cf732"+"/stat-registered-drones-by-half-month").then((response) => {
				this.total = response.data.data.total;
				const chartDataset = this.convertDataset(response.data.data.dataset,response.data.data.labels)
				const chartOptions = {
					scales : {
						yAxes : [
							{ticks:{min : 0,precision : 0,suggestedMax:response.data.data.maxValue+1}}
						] ,
					}
				}
				this.$refs.chart.applyChartData(chartDataset,chartOptions)
			}).catch((error) => {
				this.error = ApiError.getDisplayErrorMessage(this,error)
			}).finally(() => {
				this.loading = false
			});
		}
	}
}
</script>
